import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Customer,
  CustomerContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-customer',
  template: Customer.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Customer.height;
  @Input() public viewBox: string = getSVGViewBox(Customer.viewBox);
  @Input() public width: number | string = Customer.width;
  @Input()
  public set context(ctx: CustomerContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: CustomerContext = Customer.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = CustomerComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Customer.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
